import React from 'react';
import classNames from 'classnames';
var css = {
  "reactBottomSheet": "rui-SIP5r"
};
var BottomSheet = function BottomSheet(_ref) {
  var customStyle = _ref.customStyle,
    overflowHeight = _ref.overflowHeight,
    sheetHeight = _ref.sheetHeight,
    open = _ref.open,
    children = _ref.children;
  var styles = {
    root: {
      height: open ? sheetHeight : overflowHeight
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(css.reactBottomSheet, customStyle),
    style: styles.root
  }, children);
};
BottomSheet.defaultProps = {
  open: false,
  overflowHeight: 50,
  sheetHeight: 0,
  customStyle: ''
};
export default BottomSheet;